import * as classnames from 'classnames';
import * as React from 'react';

import { Overlay } from 'components/Overlay';

import './Sidemenu.scss';

interface SidemenuProps {
  className?: string;
  onOverlayClick?: MSExecAtPriorityFunctionCallback;
  isOpen?: boolean;
}

export class Sidemenu extends React.Component<SidemenuProps, {}> {
  render() {
    const { children, className, isOpen, onOverlayClick } = this.props;
    const classNameSidemenuIsOpen = isOpen ? 'is-open' : 'is-close';
    return (
      <aside className="sidemenu">
        <div className={classnames('sidemenu__container', `sidemenu__container--${classNameSidemenuIsOpen}`, className)}>
          {children}
        </div>
        <Overlay
          className={classnames('sidemenu__overlay', `sidemenu__overlay--${classNameSidemenuIsOpen}`)}
          modifier="clickable"
          onClick={onOverlayClick}
        />
      </aside>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Sidemenu/Sidemenu.tsx